module.exports = __webpack_public_path__ + "images/novox_smalla61111eb08a2eb79da2a4836e82eaf77.png";